import { DEFAULT_CLASTER_GRID_SIZE, DEFAULT_CLASTER_ICON_COLOR } from '../constants';

/**
 * Из сокращенных переданных настроек для кластаризации делает объект опциий для ObjectManager яндекс карт
 * {@link https://tech.yandex.ru/maps/jsapi/doc/2.1/ref/reference/Clusterer-docpage/|Документация яндекс карт}
 * @returns Возвращает объект настройки кластаризации
 */
export var getClustersOptions = function getClustersOptions(options) {
  if (!options || !options.clusterize) {
    return {};
  }
  var _options$iconColor = options.iconColor,
    iconColor = _options$iconColor === void 0 ? DEFAULT_CLASTER_ICON_COLOR : _options$iconColor,
    _options$gridSize = options.gridSize,
    gridSize = _options$gridSize === void 0 ? DEFAULT_CLASTER_GRID_SIZE : _options$gridSize;
  return {
    clusterize: true,
    gridSize: gridSize,
    clusterIconColor: iconColor,
    options: {
      clusterIconLayout: 'cluster#icon',
      hasHint: false
    }
  };
};